import { render, staticRenderFns } from "./ReportsDeliveryVehicleView.vue?vue&type=template&id=0951f300"
import script from "./ReportsDeliveryVehicleView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryVehicleView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports